import { render, staticRenderFns } from "./DetailContent.vue?vue&type=template&id=f86921f8&scoped=true&"
import script from "./DetailContent.vue?vue&type=script&lang=js&"
export * from "./DetailContent.vue?vue&type=script&lang=js&"
import style0 from "./DetailContent.vue?vue&type=style&index=0&id=f86921f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86921f8",
  null
  
)

export default component.exports